<template>
    <b-modal
        id="edit-personal-internship"
        v-model="load"
        ref="edit-personal-internship"
        size="lg"
        :title="$t('internship.add_here_your_internship_function')"
        modal-class="apprentice-default-modal edit-personal-internship"
        :ok-title="$t('common.edit')"
        cancel-variant="outline-primary"
        :cancel-title="$t('common.cancel')"
        @ok="save()">
        <div class="personal-internship-edit">
            <b-alert
                variant="warning"
                show
                >{{ $t('common.all_fields_are_mandatory') }}</b-alert
            >
            <b-form-group
                class="internship-name"
                label-for="internship-name-input"
                :label="$t('common.name')">
                <b-form-input
                    id="internship-name-input"
                    v-model="name"
                    :placeholder="$t('internship.function_title')">
                </b-form-input>
            </b-form-group>
            <b-form-group
                class="internship-organization"
                label-for="internship-organization-input"
                :label="$t('common.organization')">
                <b-form-input
                    id="internship-organization-input"
                    v-model="organization"
                    :placeholder="$t('internship.name_organisation')">
                </b-form-input>
            </b-form-group>

            <b-form-group
                class="personal-internship-organization"
                label-for="personal-internship-organization-input"
                :label="$t('internship.name_supervisor')">
                <template #label> Naam stagebegeleider: <span class="required">*</span> </template>
                <b-form-input
                    id="personal-internship-organization-input"
                    v-model="supervisor"
                    :placeholder="$t('internship.name_supervisor')">
                </b-form-input>
            </b-form-group>

            <b-form-group
                class="internship-location"
                label-for="internship-location-input"
                :label="$t('common.location')">
                <b-form-input
                    id="internship-location-input"
                    v-model="location"
                    :placeholder="$t('common.location')">
                </b-form-input>
            </b-form-group>

            <b-form-group
                class="internship-description"
                label-for="internship-description-input"
                :label="$t('common.location')">
                <b-form-textarea
                    class="apprentice-textarea"
                    id="internship-description-input"
                    v-model="description"
                    :placeholder="$t('common.location')"
                    rows="3"
                    max-rows="6">
                </b-form-textarea>
            </b-form-group>
        </div>
    </b-modal>
</template>

<script>
export default {
    name: 'design-2021-internships-student-personal-edit-modal-component',
    data() {
        return {
            internship: [],
            load: false,
            name: '',
            description: '',
            location: '',
            organization: '',
            supervisor: '',
        };
    },
    methods: {
        show(internship) {
            this.internship = internship;
            this.load = true;
            this.name = internship.name;
            this.description = internship.description;
            this.location = internship.location;
            this.organization = internship.organization;
            this.supervisor = internship.supervisor;
        },
        save() {
            const formData = new FormData();
            formData.append('name', this.name);
            formData.append('description', this.description);
            formData.append('location', this.location);
            formData.append('organization', this.organization);
            formData.append('supervisor', this.supervisor);

            const headers = { 'Content-Type': 'multipart/form-data' };

            axios
                .post(this.routes.studentPersonalInternshipEdit(this.internship.id), formData, { headers: headers })
                .then((response) => {
                    this.$emit('update-internship', response.data);
                })
                .catch(function (error) {
                    this.alert.ajaxError(error);
                });
        },
    },
};
</script>

<style scoped></style>
